import { ApolloClient, InMemoryCache } from "@apollo/client";
import { Chain } from "./lib/zeus";
const API_URL = (process.env.NEXT_PUBLIC_WP_URL ?? "https://api.gossipment.com") + '/graphql';

const client = new ApolloClient({
    uri: API_URL,
    cache: new InMemoryCache(),
});

export const chain = Chain(API_URL);

export default client;